import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {SrcMappingAccountCode} from "../../../model/mapping/src-mapping-account-code";
import {MappingSrcMappingAccountCodeService} from "../../../services/mapping/mapping-src-mapping-account-code.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-mapp-acc-code',
  templateUrl: './src-mapping-account-code.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SrcMappingAccountCodeComponent extends CrudBaseComponent<SrcMappingAccountCode> {

  //fields
  sources: FieldRecord<any>[];
  exchanges: FieldRecord<any>[];
  owners: FieldRecord<any>[];
  accounts: FieldRecord<any>[];

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingSrcMappingAccountCodeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new SrcMappingAccountCode();
    this.newRecord.id = -1;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
      this.formRecord.sourceAccountCode = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'sourceCode',
        width: 130
      },
      {
        field: 'crystalOwner',
        width: 130
      },
      {
        field: 'crystalExchangeCode',
        width: 130,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.crystalExchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'crystalAccountCode',
        width: 130
      },
      {
        field: 'sourceAccountCode',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'sourceCode',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.sources,
          },
          {
            field: 'crystalExchangeCode',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            }
          },
          {
            field: 'crystalOwner',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.owners,
            changed: event => {
              this.formRecord.crystalOwner = event.text;
            }
          },
          {
            field: 'crystalAccountCode',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.accounts,
            changed: event => {
              this.formRecord.crystalAccountCode = event.text;
            }
          },
          {
            field: 'sourceAccountCode',
            required: true,
            column: 4,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getSources(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.sources = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 4;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 4;
    });

    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 4;
    });

    this.commonFieldService.getAccounts(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.accounts = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 4;
    });

  }

  onFormShow() {
  }
}
